import React from 'react';

interface CustomButtonProps {
    children: React.ReactNode;
    onClick?: () => void;
    variant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'success' | 'warning';
    size?: 'small' | 'medium' | 'large';
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    className?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
    children,
    onClick,
    variant = 'primary',
    size = 'medium',
    disabled = false,
    type = 'button',
    className = '',
}) => {
    const getVariantClass = () => {
        switch (variant) {
            case 'secondary':
                return 'btn-secondary';
            case 'outline':
                return 'btn-outline-primary';
            case 'danger':
                return 'btn-danger';
            case 'success':
                return 'btn-success';
            case 'warning':
                return 'btn-warning';
            default:
                return 'btn-primary';
        }
    };

    const getSizeClass = () => {
        switch (size) {
            case 'small':
                return 'btn-sm';
            case 'large':
                return 'btn-lg';
            default:
                return '';
        }
    };

    return (
        <button
            type={type}
            className={`btn ${getVariantClass()} ${getSizeClass()} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default CustomButton; 